import React, { Component } from "react" 
import { NavLink } from 'react-router-dom'

import { Logo, Img, ArEn, SearchBar, SearchBtn } from "../UI/UI";
import { isMobile, getUrl } from "../../Utility/Utility";
import "./Menu.css";


const appCountrys = [
  {langCode: "de", subDomain: "de", countryName: "Deutsch"},
  // {langCode: "nl", subDomain: "nl", countryName: "Dutch"},
  // {langCode: "at", subDomain: "at", countryName: "Österreich"},
  // {langCode: "pl", subDomain: "pl", countryName: "Polski"},
  // {langCode: "ro", subDomain: "ro", countryName: "Română"},
  // {langCode: "se", subDomain: "se", countryName: "Svenska"},
  // {langCode: "ch", subDomain: "ch", countryName: "Schwyzerdütsch"},
  // {langCode: "cz", subDomain: "cz", countryName: "Cseh"},
  // {langCode: "dk", subDomain: "dk", countryName: "Danish"},
  // {langCode: "hu", subDomain: "hu", countryName: "Magyar"},
  {langCode: "gb", subDomain: "uk", countryName: "English"},
  {langCode: "ru", subDomain: "ru", countryName: "Русский"},
  {langCode: "fr", subDomain: "fr", countryName: "Français"},
  {langCode: "es", subDomain: "es", countryName: "Español"},
  {langCode: "it", subDomain: "it", countryName: "Italiana"},
  {langCode: "eu", subDomain: "eu", countryName: "الإمارات العربية المتحدة"},
  {langCode: "eu-en", subDomain: "eu-en", countryName: "United Arab Emirates"},
  {langCode: "pt", subDomain: "pt", countryName: "Portuguese"},

];

const CurrentFlagIcon = ( props ) => {
  var lang = ( props.lang ) ?  props.lang  : "" ;
  var langName = ( props.langName ) ?  props.langName  : "" ;
  var hideArrow = ( props.hideArrow === true ) ?  true  : false ;

  let arrow = null;

  if ( hideArrow == false ) {
    arrow = <Img desktopImg={'/right-arrow-wb.png'}  cssClass={'bottom-arrow'} />;
  }
  if ( isMobile() ){  
    return(
      <div className="flat-icon-div">
        <div className={'flat-icon-wrapper flat-icon-' + lang} >
          <button onClick={props.setLangState}>
            <Img desktopImg={'/flags/4x3/'+lang+'.svg'}  />
            <div>
              <p>
              {langName}
              </p>
            </div>
            {arrow}
          </button>
        </div>
      </div>
    )
  }else {
    return(
        <div className={'flat-icon-wrapper flat-icon-' + lang} >
          <button onClick={props.setLangState}>
            <Img desktopImg={'/flags/4x3/'+lang+'.svg'}  />
            <div>
              <p>
              {langName}
              </p>
            </div>
            {arrow}
          </button>
        </div>
    );
  }
}

class Menu extends Component {
  state = {
    isOpen : false ,
    isLangOpen: false,
    isHover: false,
    keyWord: '',
    isSearchBarOpen:false,
    isPopupOpen:''
  }

  
  getSearchValue = (e) => {

    this.setState({
      keyWord:e.target.value
    })
  }

  onkeyUp = (e) => {
    if ( this.state.keyWord == ''){

    } else {

      if (e.key === "Enter") {
        console.log(getUrl());
        window.location.href = getUrl() + '/Pages/SearchPage/?q=' + e.target.value;
      }
      // this.setState({ isPopupOpen:'ac-open' });

    }
    
  }
  onBlur = (e) => {

    if(isMobile()) {

      window.location.href = getUrl() + '/Pages/SearchPage/?q=' + e.target.value;
    } else {
      null
    }
  }

  showSearchResults = () => {
    if ( this.state.keyWord == ''){

       alert('يعني ، من فضلك اكتب كلمة بحث. نعم');
    } else {

      window.location.href = getUrl() + '/Pages/SearchPage/?q=' + this.state.keyWord;
    }

  }

  showSearchBar = () => {

    if(this.state.isSearchBarOpen == false){
      this.setState({isSearchBarOpen:true})
      console.log('this.state.isSearchBarOpen:', this.state.isSearchBarOpen);
    }else {
       this.setState({isSearchBarOpen:false});
       console.log('this.state.isSearchBarOpen:', this.state.isSearchBarOpen);
    }

  }

  setMenuState = () => {
   if ( this.state.isLangOpen ){    
      this.setState({
        isLangOpen : !this.state.isLangOpen,
        isOpen : !this.state.isOpen
      })
    }else {
      this.setState({
        isOpen : !this.state.isOpen
      })
    }
  } 
   redirect = (subDomain) => {

     if( (subDomain === "de" ) || (subDomain === "at" )|| (subDomain === "ch" )|| (subDomain === "en" ) || (subDomain === "pl" ) || (subDomain === "it" ) || (subDomain === "es" ) || (subDomain === "ru" ) || (subDomain === "fr" ) || (subDomain === "eu" ) || (subDomain === "eu-en" )){
       
         window.location.href =  'https://new.goisrael.com/' + subDomain;

     } else  if( subDomain === "pt" ){
      window.location.href = 'https://goisrael.com.br/';
     } else {

         window.location.href =  'https://new.goisrael.com/international/?lang=' + subDomain;
         // window.location.href =  'http://localhost:3000/international/?lang=' + subDomain;
     }

             
  }

  setLangState = () => {
    if ( isMobile() ){    
      this.setState({
        isLangOpen : !this.state.isLangOpen,
        isOpen : !this.state.isOpen
      })
    }else {
      this.setState({
        isLangOpen : !this.state.isLangOpen,
      })      
    }
  } 
  render(){
  
    
    const isLangOpen = this.state.isLangOpen;
    let cssClass ="inner";
     let parentCssClass ="";

    if ( this.state.isOpen === true ) {
      cssClass += " open"
    }

    var countryContainer = null;
    var countryCssClass = 'country-close';

    if ( isLangOpen ) {
        countryCssClass ='country-open'
        countryContainer = appCountrys.map((o) => {
          return  <CurrentFlagIcon lang={o.langCode} langName={o.countryName} setLangState={() => {
            this.redirect(o.subDomain)
          }} hideArrow ={true}  />
                
        })
    }

    var langName = 'العربيه';
    var langCode = 'eu';
    //  var CurrentLang = 'دولة الإمارات العربية المتحدة';
    var CurrentLang = 'العربيه';
   
    // var CurrentLang = localStorage.getItem('currentLang');

    if ( CurrentLang != null ) {
      langName = CurrentLang.toUpperCase();
      if ( CurrentLang == "العربيه"){
        langCode = 'eu';
      }else {
        // langCode = CurrentLang;
        CurrentLang = 'العربيه';
      }
      
    }



    // alert(langName);

    return(
    <div>
      {this.state.isLangOpen && <div className="nav-trigger-overlay" onClick={this.setLangState}></div>}
      <div className="menu-outer-wrapper">
        <div className="container">
          <div className="col col-15 logo-outer-wrapper">
            <NavLink  exact  className="first" to="/">
              <Logo />
            </NavLink>
          </div>
          <div className="col col-100 menu-inner-wrapper">
            <div className={cssClass}>
              <NavLink  exact  className="first" to="/">الرئيسية </NavLink>
              {/*<NavLink  exact to="/Pages/bestDeals">أفضل العروض </NavLink>*/}
              <NavLink  exact to="/Pages/whereToGo"> لا تفوّتوا زيارة هذه الأماكن  </NavLink>
              <NavLink  exact to="/Pages/thingsToDo">نشاطات ننصح بها </NavLink>
              {/*<NavLink  exact  to="/Pages/liveShows">عروض حيّة</NavLink>*/}
              <NavLink  exact to="/Pages/Gallery/">معرض الصور </NavLink>
              <NavLink  exact to="/Pages/Videos">الفيديوهات </NavLink>
              <NavLink  exact to="/Pages/TouristInfoPage">معلومات للسوّاح </NavLink>
              {/*<NavLink  exact to="/Pages/FAQ">FAQ</NavLink>*/}
              {<CurrentFlagIcon lang={langCode} langName={langName} setLangState={this.setLangState} hideArrow={false}  />}
            
               <SearchBtn cssClass={'ac-search-btn'}
                         click={this.showSearchBar}
                />
              
             
              { this.state.isSearchBarOpen ? <SearchBar cssClass={'ac-search-bar'}
                    cssClasswrapper={'ac-wrapper-search-bar'}
                    keyUp={this.onkeyUp}
                    Change={this.getSearchValue}
                    keyWord={this.state.keyWord}
                    click={this.showSearchBar}
                    cssClassPopupOpen={this.isPopupOpen}
                    clickForResults={this.showSearchResults}
                    blurOut={this.onBlur}/> : null }
              
                   {/*<ArEn />*/}  {/*this is a component for choosing a lang eu/eu-en */}
              
            </div>
            <div className="show-on-mobile">
              <button className="open-mobile-menu navbar-toggle" onClick={this.setMenuState} >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </div>
          </div>
          <div className="clear"></div>
        </div>
      </div>
      <div className={'container country-container '  + countryCssClass}>
          <div className="country-container-inner">
            <div className="country-container-title">
              <h3>  
                Choose your language:
              </h3>
            </div>
            <div className="country-container-flags-wrapper">
              {countryContainer}
            </div>
          </div>
        </div>
        </div>
    )
  }
}


export default Menu


// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.js